/**
 * Post Content WYSIWYG Interactions
 * Sayfa genelindeki WYSIWYG kutularını tarar, tüm sayfa genelinde
 * SADECE İLK uygun paragrafın ilk kelimesini bulup
 * HTML yapısını bozmadan .lead-word sınıfı ile sarmalar.
 */
export const initWysiwyg = (): void => {
  // Hem post (makale) hem de standart page alanlarındaki WYSIWYG kutularını bul
  const containers = document.querySelectorAll<HTMLElement>(
    ".post-content-wysiwyg, .wysiwyg-content__container",
  );

  if (containers.length === 0) return;

  // Sayfa genelinde "ilk kelime" efektinin sadece 1 kez uygulanmasını takip eden bayrak
  let isLeadWordApplied = false;

  // forEach yerine normal bir for döngüsü kullanıyoruz ki 'break' ile çıkabilelim
  for (let i = 0; i < containers.length; i++) {
    const container = containers[i];

    // İçinde resim OLMAYAN ve boş olmayan İLK paragrafı bul
    const paragraphs = Array.from(container.querySelectorAll("p"));
    const firstTextParagraph = paragraphs.find((p) => {
      return (
        p.textContent &&
        p.textContent.trim().length > 0 &&
        !p.querySelector("img")
      );
    });

    if (
      firstTextParagraph &&
      !firstTextParagraph.classList.contains("lead-initialized")
    ) {
      firstTextParagraph.classList.add("lead-initialized");

      // HTML etiketlerini (örneğin <strong>) bozmadan sadece metin düğümlerini
      // tarayan ve ilk kelimeyi yakalayan rekürsif fonksiyon
      const walkAndWrapFirstWord = (node: Node): boolean => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.nodeValue || "";
          // Sadece harfleri (Türkçe dahil) yakala
          const match = text.match(/([a-zA-Z0-9ğüşıöçĞÜŞİÖÇÂâÎîÛû]+)/);

          if (match && match.index !== undefined) {
            const before = text.substring(0, match.index);
            const word = match[0];
            const after = text.substring(match.index + word.length);

            const span = document.createElement("span");
            span.className = "lead-word";
            span.textContent = word;

            const parent = node.parentNode;
            if (parent) {
              if (before)
                parent.insertBefore(document.createTextNode(before), node);
              parent.insertBefore(span, node);
              if (after)
                parent.insertBefore(document.createTextNode(after), node);
              parent.removeChild(node);
            }
            return true; // Kelime bulundu ve sarmalandı
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          for (let j = 0; j < node.childNodes.length; j++) {
            if (walkAndWrapFirstWord(node.childNodes[j])) {
              return true;
            }
          }
        }
        return false;
      };

      // Efekti uygula
      const applied = walkAndWrapFirstWord(firstTextParagraph);

      if (applied) {
        isLeadWordApplied = true;
        break; // Sayfadaki İLK kelimeyi başarıyla uyguladık, diğer WYSIWYG kutularını atla.
      }
    }
  }

  console.log("[WYSIWYG] Initialized editorial lead words.");
};
